import { render } from "./DentalBridgesEat.vue?vue&type=template&id=2ee70a19"
import script from "./DentalBridgesEat.vue?vue&type=script&lang=js"
export * from "./DentalBridgesEat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__